module.exports = __webpack_public_path__ + "static/ss49e_sensor-8c23f88fa84708b436ddd0f041e37a38.webp";